import { FC, useEffect, useRef, useState } from "react";
import styles from "./login.module.scss";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";
import CustomModal from "../../componsnts/common/registerModal/modal";
import ConstomSlider from "../../componsnts/common/slider/signUp-slider/signUp-slider";

const Login: FC = () => {
  return (
    <div className={styles["login_container"]}>
      <div className="login_box">
        <div className="background_image"></div>
      </div>
    </div>
  );
};
export default Login;
